"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Email = _interopRequireDefault(require("@rsuite/icon-font/lib/file/Email"));

// Generated by script, don't edit it please.
var Email = (0, _createSvgIcon["default"])({
  as: _Email["default"],
  ariaLabel: 'email',
  category: 'file',
  displayName: 'Email'
});
var _default = Email;
exports["default"] = _default;
module.exports = exports.default;